import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import DashboardCalendarView from '../pages/master/Dashboard';
import BookingDetails from '../pages/master/BookingDetails';
import ServiceEditor from '../pages/master/ServiceEditor';
import Schedule from '../pages/master/Schedule';
import RouteGuard from '../components/common/RouteGuard';
import CreateBooking from '../pages/master/CreateBooking';
import Accounting from '../pages/master/Accounting';
import Clients from '../pages/master/Clients';
import Promos from '../pages/master/Promos';
import Cabinet from '../pages/user/Cabinet';
import BookByLink from '../pages/booking/BookByLink';
import ConfirmByLink from '../pages/booking/ConfirmByLink';
import BookSuccess from '../pages/booking/BookSuccess';
import PaymentPage from '../pages/PaymentPage';
import PaymentResult from '../pages/PaymentResult';
import Home from '../pages/Home';

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/master/dashboard" element={<RouteGuard role="master"><DashboardCalendarView /></RouteGuard>} />
      <Route path="/master/booking/:id" element={<RouteGuard role="master"><BookingDetails /></RouteGuard>} />
      <Route path="/master/services" element={<RouteGuard role="master"><ServiceEditor /></RouteGuard>} />
      <Route path="/master/schedule" element={<RouteGuard role="master"><Schedule /></RouteGuard>} />
      <Route path="/master/create" element={<RouteGuard role="master"><CreateBooking /></RouteGuard>} />
      <Route path="/master/accounting" element={<RouteGuard role="master"><Accounting /></RouteGuard>} />
      <Route path="/master/clients" element={<RouteGuard role="master"><Clients /></RouteGuard>} />
      <Route path="/master/promos" element={<RouteGuard role="master"><Promos /></RouteGuard>} />
      <Route path="/user/cabinet" element={<RouteGuard role="user"><Cabinet /></RouteGuard>} />
      <Route path="/book/:hash" element={<BookByLink />} />
      <Route path="/book" element={<BookByLink />} />
      <Route path="/confirm/:hash" element={<ConfirmByLink />} />
      <Route path="/book-success" element={<BookSuccess />} />
      <Route path="/pay/:hash" element={<PaymentPage />} />
      <Route path="/payment/:status" element={<PaymentResult />} />
    </Routes>
  );
}
